import sanityClient from "@sanity/client";

const client = sanityClient({
    projectId: "zaah1iwi",
    dataset: "production",
    useCdn: true // `false` if you want to ensure fresh data
});

export default async (query) => {
    const response = await client.fetch(query);
    return response;
};
